import dev from '../../client_config/dev.json';
import prod from '../../client_config/prod.json';
import stage from '../../client_config/stage.json';
import type { ClientConfig } from './';

/**
 * Maps deployment `env` (from runtime config) to the bundled dev/stage/prod JSON.
 * Single source of truth for environment selection — used by hooks and URL helpers.
 */
export const getClientConfigForEnv = (env?: string): ClientConfig => {
  if (!env) return dev;
  // Stage before dev: strings like "develop-stage-1" contain both "stage" and the substring "dev"
  // in "develop"; stage must win.
  if (env.includes('stage')) return stage;
  if (env.includes('dev')) return dev;
  return prod;
};
